import CoachingReviewActions from 'actions/coaching/CoachingReviewActions';
import CallActions from 'actions/CallActions';
import ScorecardActions from 'actions/scorecards/ScorecardActions';
import {Set} from 'immutable';

export default async function loadDataForReview(review, callStore) {
  const {reviewFileUploads} = await CoachingReviewActions.fetchReviewFeedback(review.id);
  const fileuploadIds = reviewFileUploads.map(({fileuploadId}) => fileuploadId);
  const unpulled = fileuploadIds.filter(
    id => !callStore || !callStore.partiallyHydratedCalls.get(id)
  );
  if (unpulled.size > 0) {
    CallActions.getPartiallyHydratedCalls(unpulled);
  }

  const questionIds = reviewFileUploads
    .map(reviewFileUpload => reviewFileUpload.reviewFeedbackList.map(rf => rf.scorecardQuestionId))
    .flatten()
    .filter(id => id);

  // note that we pull questions very purposefully by the review feedback.
  // this is because review feedback could give us inactive questions
  setTimeout(async () => {
    const questions = await Promise.all(
      questionIds.map(qid => ScorecardActions.fetchScorecardQuestionById(qid))
    );
    const scorecardIds = Set(questions.map(q => q.scorecardId));
    scorecardIds.map(id => ScorecardActions.fetchScorecard.defer(id));
  }, 0);
}
